<div [class]="'w-fit-content special-categories-card  '+item().borderClass" (click)="onCategoryClicked()" role="button">
  <div class="d-flex align-items-center gap-3">
    <img [src]="item().specialIcon || 'assets/images/product-placeholder-sm.webp'" class="img-fluid object-fit-cover"
      alt="." width="80" height="55" loading="lazy" decoding="async" />
    <span class="special-categories-card__title">
      {{item().name}}
    </span>
  </div>
</div>
